module.exports = __webpack_public_path__ + "img/banner.0ae924f2.png";